/* Zumzz gift guard v2:
   - automatski DODAJ gratis poklon kad subtotal dosegne prag
   - automatski ga MAKNI kad subtotal (bez poklona) padne ispod praga
   - bez utrke s teminim renderom: reagira NAKON temine cart operacije,
     a vlastite promjene renderira kroz temin cart-drawer.renderContents. */
(function () {
  var busy = false;
  var timer = null;
  var DISMISS = 'zz_gift_added';

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function cfg() {
    var el = document.querySelector('[data-zz-gift-config]');
    if (!el) return null;
    var req = parseInt(el.dataset.requirement, 10);
    var vid = parseInt(el.dataset.id, 10);
    if (!req || !el.dataset.handle || !vid) return null;
    return { handle: el.dataset.handle, req: req, variantId: vid };
  }

  function sectionNames() {
    var d = drawerEl();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function render(resp) {
    var d = drawerEl();
    if (d && typeof d.renderContents === 'function' && resp && resp.sections) {
      try { d.renderContents(resp); } catch (e) {}
    }
  }

  function cartOp(url, body) {
    busy = true;
    body.sections = sectionNames();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) { render(resp); busy = false; })
      .catch(function () { busy = false; });
  }

  function check() {
    if (busy) return;
    var c = cfg();
    if (!c) return;
    fetch('/cart.js', { headers: { 'zz-guard': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (busy) return;
        var gift = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle === c.handle) { gift = cart.items[i]; break; }
        }

        if (gift) {
          var rest = cart.items_subtotal_price - gift.final_line_price;
          if (rest < c.req) {
            try { sessionStorage.removeItem(DISMISS); } catch (e) {}
            cartOp('/cart/change.js', { id: gift.key, quantity: 0 });
          } else if (gift.quantity > 1) {
            cartOp('/cart/change.js', { id: gift.key, quantity: 1 });
          }
          return;
        }

        if (cart.items_subtotal_price >= c.req && cart.item_count > 0) {
          var dismissed = false;
          try { dismissed = sessionStorage.getItem(DISMISS) === '1'; } catch (e) {}
          if (dismissed) return; // ručno maknut — ne guraj ponovno dok ne padne ispod praga
          try { sessionStorage.setItem(DISMISS, '1'); } catch (e) {}
          cartOp('/cart/add.js', { items: [{ id: c.variantId, quantity: 1, properties: { _zz_gift: '1' } }] });
        } else {
          try { sessionStorage.removeItem(DISMISS); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 300);
  }

  // reagiraj tek NAKON što temina cart operacija završi
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var isCartOp = /\/cart\/(add|change|update|clear)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCartOp && !busy) {
      p.then(function () { schedule(); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
